import { defineComponent, h, PropType, watch } from 'vue';
import { coming_soon } from '@components/icons';
import { handle } from '../../set-button-state';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { shift_pressed } from '@frontend/keypress';
import { img } from '@phi/components';
import bridge_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/handle.svg';
import BridgeTooltip from './BridgeTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const BridgeIcon = bridge_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    data() {
        return {
            callback: undefined as ReturnType<typeof handle>,
        };
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Bridge';
        },

        disabled() {
            return this.state.editing_reference_sketches
                || !this.callback;
        },
    },

    mounted() {
        watch(
            () => this.state.selected_edges_count + this.state.selected_faces_count + this.state.selected_vertices_count,
            () => {
                this.callback = handle();
            },
        );
    },

    methods: {
        onClick() {
            if (this.disabled) return;
            else if (this.callback) this.callback(shift_pressed());
        },

        onLongClick() {
            if (this.disabled) return;
            else if (this.callback) this.callback(true);
        },
    },

    render() {
        return h(BarButton, {
            id: 'handle-button',
            wrapperId: 'handle-wrapper',
            disabled: this.disabled,
            active: false,
            tippy: 'left',
            long: true,
            onClick: this.onClick,
            onLongClick: this.onLongClick,
            selected: this.state.tut_stage === 4,
            help: 'bridge',
        }, {
            label: () => 'Bridge',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(bridge_svg, this.alt),
            tooltip: BridgeTooltip,
        });
    },
});
